import { styled } from '@linaria/react';
import { fonts, layout, primitives, semantic, size } from '../../theme/tokens';

export const StyledInput = styled.input<{ $variant: 'borderless' | 'outlined'; $error?: boolean }>`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${semantic.text.primary};
  padding: ${layout.inputPadding};
  border: ${(p) =>
    p.$variant === 'outlined'
      ? `${p.$error ? size.stroke['stroke-thick'] : size.stroke['stroke-default']} solid ${
          p.$error ? semantic.border.danger : semantic.border.default
        }`
      : 'none'};
  border-radius: ${(p) => (p.$variant === 'outlined' ? size.radius['radius-md'] : '0')};
  outline: none;
  width: 100%;
  box-sizing: border-box;
  background: transparent;

  &::placeholder {
    color: ${semantic.text.tertiary};
  }

  &:hover {
    border-color: ${(p) => (p.$variant === 'outlined' ? semantic.border.secondary : 'transparent')};
  }

  &:focus {
    background: ${(p) => (p.$variant === 'borderless' ? semantic.bg.surfaceSubtle : 'transparent')};
    border-width: ${(p) => (p.$variant === 'outlined' ? size.stroke['stroke-thick'] : '0')};
    border-color: ${(p) => (p.$variant === 'outlined' ? semantic.border.selected : 'transparent')};
  }

  &:disabled {
    color: ${semantic.text.disabled};
    cursor: not-allowed;
    border-color: ${(p) => (p.$variant === 'outlined' ? semantic.border.default : 'transparent')};
  }

  &:disabled::placeholder {
    color: ${semantic.text.disabled};
  }

  &[aria-invalid='true'] {
    border-width: ${(p) => (p.$variant === 'outlined' ? size.stroke['stroke-thick'] : '0')};
    border-color: ${(p) => (p.$variant === 'outlined' ? semantic.border.danger : 'transparent')};
  }
`;
